'use client'
import React from 'react'
import {
  Box,
  Center,
  Heading,
  Text,
  Stack,
  Avatar,
  useColorModeValue,
  Image,
  BoxProps
} from '@chakra-ui/react'
import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import {NavLink} from "react-router-dom";
import {convertToSlug} from '../pages/news.js';


interface Props extends BoxProps {
    image: Array<string>;
    title: string;
    date: string;
    text: any;
    onClose: () => void;
  };

export default function BlogPostWithImage({image,title, date, text, onClose}: Props) {
  console.log(date)
  return (
    <Box w="100%" maxW="100%" minW={0}>
      <NavLink to = {convertToSlug(title)} onClick={onClose} style={{ width: "100%", display: "block" }}>
      <Box
        w={'100%'}
        minW={0}
        // eslint-disable-next-line react-hooks/rules-of-hooks
        bg='gray.900'
        boxShadow={'2xl'}
        rounded={'md'}
        p={6}
        overflow={'hidden'}
        _hover={{ 
          bg: "gray.200",
          transform: "scale(1.02)",
          transition: "all 0.2s ease-in-out",
          }}
          _active={{
            bg: "gray.500",
            transform: "scale(0.98)",
          }}>
          <Box
            h={{ base: "110px", sm: "160px", md: "210px" }}
            mt={-6}
            mx={-6}
            mb={6}
            pos="relative"
            overflow="hidden"
          >          <Image
              src={image.toString()}
              objectFit='cover'
              width='100%'
              height='100%'
              alt="Example"
            />
        </Box>
        <Stack>
          <Text
            color={'orange.400'}
            textTransform={'uppercase'}
            fontWeight={800}
            fontSize={'sm'}
            letterSpacing={1.1}>
            Nieuws
          </Text>
          <Heading
            // eslint-disable-next-line react-hooks/rules-of-hooks
            color='white'
            fontSize={{ base: "lg", sm: "xl", md: "2xl" }}
            fontFamily={'body'}>
            {title}
          </Heading>
            <Box
              px={{ base: 0, sm: 4 }}
              sx={{
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: { base: 1, sm: 2, md: 3 },
                overflow: "hidden",
              "& p": {
                    margin: 0, // ✅ remove paragraph spacing from BlocksRenderer
                  }
              }}
              color="white"
            >
            <BlocksRenderer content = {text}/>
          </Box>
        </Stack>
        <Stack mt={6} direction={'row'} spacing={4} align={'center'}>
          <Avatar src={'https://api.sint-kristoffel.be/uploads/thumbnail_logo_met_mannetje_web_Tekengebied_1_d1d8e927e7.png'} />
          <Stack direction={'column'} spacing={0} fontSize={'sm'}>
            <Text fontWeight={600} textColor='white'>Groepsleiding</Text>
            //<Text color={'white'}>{date.slice(8,10).concat('/').concat(date.slice(5,7)).concat('/').concat(date.slice(0,4))}</Text>
          </Stack>
        </Stack>
      </Box>
      </NavLink>
    </Box>
  )
}